// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { LMcategories, DealerEngineCategories } from './types';
import { EngineCategory } from './types';

export interface ActionGetLMCategoriesAPI extends Action {
    listingId: string
}

export const getLMCategoriesAPI = (listingId: string): ActionGetLMCategoriesAPI => ({
    type: ACTIONS.GET_LMCATEGORIES_API_REQUEST,
    listingId,
});

export interface ActionGetLMCategoriesAPISuccess extends Action {
    lmcategories: LMcategories
}

export const getLMCategoriesAPISuccess = (lmcategories: LMcategories): ActionGetLMCategoriesAPISuccess => ({
    type: ACTIONS.GET_LMCATEGORIES_API_SUCCESS,
    lmcategories
});

export const getLMCategoriesAPIError = (): Action => ({
    type: ACTIONS.GET_LMCATEGORIES_API_ERROR,
});


export interface ActionPostLMCategoriesAPI extends Action {
    listingId: string
    idengine?: string
    iddealer?: string
    engineCategories?: DealerEngineCategories
}

export const postLMCategoriesAPI = (listingId: string, idengine?: string, iddealer?: string, engineCategories?: DealerEngineCategories): ActionPostLMCategoriesAPI => ({
    type: ACTIONS.POST_LMCATEGORIES_API_REQUEST,
    listingId,
    idengine,
    iddealer,
    engineCategories
});

export interface ActionPostLMCategoriesAPISuccess extends Action {
    engineCategories?: DealerEngineCategories
}

export const postLMCategoriesAPISuccess = (engineCategories?: DealerEngineCategories): ActionPostLMCategoriesAPISuccess => ({
    type: ACTIONS.POST_LMCATEGORIES_API_SUCCESS,
    engineCategories
});

export const postLMCategoriesAPIError = (): Action => ({
    type: ACTIONS.POST_LMCATEGORIES_API_ERROR,
});



export interface ActionGetEngineCategoryAPI extends Action {
    idengine: string;
    country: string;
    language: string;
    page?: number
    limit?: number
    query?: string
}

export const getEngineCategoryAPI = (idengine: string, country: string, language: string, page?: number, limit?: number, query?: string): ActionGetEngineCategoryAPI => ({
    type: ACTIONS.GET_ENGINECATEGORY_API_REQUEST,
    idengine,
    country,
    language,
    page,
    limit,
    query,
});

export interface ActionGetEngineCategoryApiSuccess extends Action {
    enginecategories: EngineCategory[]
    page?: number
}

export const getEngineCategoryAPISuccess = (enginecategories: EngineCategory[], page?: number): ActionGetEngineCategoryApiSuccess => ({
    type: ACTIONS.GET_ENGINECATEGORY_API_SUCCESS,
    enginecategories,
    page
});

export const getEngineCategoryAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_ENGINECATEGORY_API_ERROR,
    error
});

export const categoryLoadMore = () => ({
    type: ACTIONS.ENGINECATEGORY_LOAD_MORE
})

export interface ActionEditEngineCategorySearchQuery extends Action {
    query: string
}

export const editEngineCategorySearchQuery = (query: string): ActionEditEngineCategorySearchQuery => ({
    type: ACTIONS.EDIT_ENGINECATEGORY_SEARCH_QUERY,
    query
})

//Edit Selected Dealer
export interface ActionEditSelectedEngineCategory extends Action {
    enginecategory?: EngineCategory
}

export const editSelectedEngineCategory = (enginecategory?: EngineCategory): ActionEditSelectedEngineCategory => ({
    type: ACTIONS.EDIT_SELECTED_ENGINECATEGORY,
    enginecategory
})

//Edit Live Category
export interface ActionEditLiveCategory extends Action {
    category?: DealerEngineCategories
}

export const editLiveCategory = (category?: DealerEngineCategories): ActionEditLiveCategory => ({
    type: ACTIONS.EDIT_LIVE_CATEGORIES,
    category
})